module.exports = __webpack_public_path__ + "static/media/gryphon_x_ids_video.20fbd13d.jpg";